"use strict";
/**
 * Mermaid Diagram Types
 *
 * Mermaid diagrams are first-class project documents stored in the DOCUMENTS table
 * with documentType: 'mermaid_diagram'. They follow the same pattern as wiring diagrams.
 *
 * Use cases:
 * - Block diagrams generated from wiring diagram connectivity
 * - Sequence diagrams for interface handshakes
 * - State machine diagrams from BITE/software requirements
 * - ER diagrams for data models
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=mermaid-diagram.js.map